import api, { apiPrefix, adminApiPrefix } from './Api';
import {
  Settings,
  settingsFromResponse,
  settingsToUpsertRequest,
} from '../interfaces/Settings/Settings';
import { genericValueFromResponse } from '../interfaces/Settings/GenericSettingsValue';
import {
  FrontendSettings,
  frontendSettingsFromResponse,
} from '../interfaces/Settings/FrontendSettings';

const settingsApiPrefix = `${apiPrefix}/settings`;
const settingsAdminApiPrefix = `${adminApiPrefix}/settings`;

export const upsertSettings = async (
  settingsToUpsert: Settings[],
): Promise<void> =>
  api.post(settingsAdminApiPrefix, {
    updates: settingsToUpsert.map((s) => settingsToUpsertRequest(s)),
  });

export const upsertMediaSettings = async (
  settingsType: string,
  key: string,
  mediaFile: File,
): Promise<void> => {
  const bodyFormData = new FormData();

  bodyFormData.append('type', settingsType);
  bodyFormData.append('key', key);
  bodyFormData.append('media', mediaFile);

  return api.post(`${settingsAdminApiPrefix}/media`, bodyFormData);
};

export const generateStyles = async (
  userRequest: string,
  currentSx: string,
): Promise<string> => {
  const response = await api.post(`${settingsAdminApiPrefix}/generate-styles`, {
    user_request: userRequest,
    current_sx: currentSx,
  });

  return response.data?.generated_sx ?? '';
};

export const getSettingsByType = async (
  settingsType: string,
): Promise<Settings[]> => {
  const response = await api.get(settingsAdminApiPrefix, {
    params: { type: settingsType },
  });

  return (response.data?.data ?? []).map((s: any) => settingsFromResponse(s));
};

export const getFeURL = async (): Promise<string> => {
  const response = await api.get(`${settingsAdminApiPrefix}/fe-url`);

  const genericValue = genericValueFromResponse(response.data);
  return genericValue.stringValue ?? '';
};

export const getMediaPrefix = async (): Promise<string> => {
  const response = await api.get(`${settingsAdminApiPrefix}/media-prefix`);

  const genericValue = genericValueFromResponse(response.data);
  return genericValue.stringValue ?? '';
};

export const getFrontendSettings = async (): Promise<FrontendSettings> => {
  const response = await api.get(settingsApiPrefix);

  return frontendSettingsFromResponse(response.data.data);
};

export const deleteSettings = async (
  settingsType: string,
  keys: string[],
): Promise<void> =>
  api.delete(settingsAdminApiPrefix, { data: { type: settingsType, keys } });
